// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pages/UserAccount/Layout/UserAccountGridLayout.css */

/* ── root ── */
.uag-grid-root {
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
  }
  
  /* ── grid ── */
  .uag-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
  }
  
  /* ── card ── */
  .uag-card {
    background: rgba(36, 36, 45, 0.2);
    border: 1px solid gray;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.18s ease, border-color 0.18s ease;
    outline: none;
  }
  
  .uag-card:hover,
  .uag-card:focus {
    transform: translateY(-3px);
  }
  
  /* media wrapper */
  .uag-card__media-wrapper {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    background: #0d0f1a;
  }
  
  .uag-card__media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.22s ease;
  }
  
  .uag-card:hover .uag-card__media {
    transform: scale(1.04);
  }
  
  /* overlay */
  .uag-card__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 60%);
    display: flex;
    align-items: flex-end;
    padding: 8px;
    opacity: 0;
    transition: opacity 0.18s ease;
  }
  
  .uag-card:hover .uag-card__overlay {
    opacity: 1;
  }
  
  .uag-card__overlay-stat {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #e0e0e0;
    font-size: 12px;
  }
  
  /* meta */
  .uag-card__meta {
    padding: 10px 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  
  .uag-card__meta-row {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #9ca3af;
    font-size: 11.5px;
  }
  
  .uag-card__meta-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  
  .uag-card__description {
    margin: 4px 0 0;
    color: #c9d1d9;
    font-size: 12px;
    line-height: 1.45;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  /* ── states ── */
  .uag-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    gap: 14px;
    color: #9ca3af;
    padding: 32px 16px;
  }
  
  .uag-state__icon {
    color: #4b5563;
    opacity: 0.7;
  }
  
  .uag-state__icon--error {
    color: #ef4444;
    opacity: 0.85;
  }
  
  .uag-state__text {
    font-size: 15px;
    font-weight: 500;
    color: #d1d5db;
    margin: 0;
  }
  
  .uag-state__subtext {
    font-size: 12.5px;
    color: #6b7280;
    margin: 0;
    text-align: center;
    max-width: 420px;
  }
  
  /* spinner */
  .uag-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #2a2d3e;
    border-radius: 50%;
    animation: uag-spin 0.75s linear infinite;
  }
  
  @keyframes uag-spin {
    to { transform: rotate(360deg); }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/UserAccountPage/Styles/UserAccountGridLayout.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD,eAAe;AACf;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA,eAAe;EACf;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA,eAAe;EACf;IACE,iCAAiC;IACjC,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yDAAyD;IACzD,aAAa;EACf;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA,kBAAkB;EAClB;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA,YAAY;EACZ;IACE,kBAAkB;IAClB,QAAQ;IACR,yEAAyE;IACzE,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,UAAU;IACV,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;;EAEA,SAAS;EACT;IACE,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,YAAY;EACZ;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,KAAK,yBAAyB,EAAE;EAClC","sourcesContent":["/* Pages/UserAccount/Layout/UserAccountGridLayout.css */\n\n/* ── root ── */\n.uag-grid-root {\n    width: 100%;\n    padding: 16px;\n    box-sizing: border-box;\n  }\n  \n  /* ── grid ── */\n  .uag-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 16px;\n  }\n  \n  /* ── card ── */\n  .uag-card {\n    background: rgba(36, 36, 45, 0.2);\n    border: 1px solid gray;\n    border-radius: 10px;\n    overflow: hidden;\n    cursor: pointer;\n    transition: transform 0.18s ease, border-color 0.18s ease;\n    outline: none;\n  }\n  \n  .uag-card:hover,\n  .uag-card:focus {\n    transform: translateY(-3px);\n  }\n  \n  /* media wrapper */\n  .uag-card__media-wrapper {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 1 / 1;\n    overflow: hidden;\n    background: #0d0f1a;\n  }\n  \n  .uag-card__media {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    transition: transform 0.22s ease;\n  }\n  \n  .uag-card:hover .uag-card__media {\n    transform: scale(1.04);\n  }\n  \n  /* overlay */\n  .uag-card__overlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 60%);\n    display: flex;\n    align-items: flex-end;\n    padding: 8px;\n    opacity: 0;\n    transition: opacity 0.18s ease;\n  }\n  \n  .uag-card:hover .uag-card__overlay {\n    opacity: 1;\n  }\n  \n  .uag-card__overlay-stat {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    color: #e0e0e0;\n    font-size: 12px;\n  }\n  \n  /* meta */\n  .uag-card__meta {\n    padding: 10px 12px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n  }\n  \n  .uag-card__meta-row {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    color: #9ca3af;\n    font-size: 11.5px;\n  }\n  \n  .uag-card__meta-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n  }\n  \n  .uag-card__description {\n    margin: 4px 0 0;\n    color: #c9d1d9;\n    font-size: 12px;\n    line-height: 1.45;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n  \n  /* ── states ── */\n  .uag-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 320px;\n    gap: 14px;\n    color: #9ca3af;\n    padding: 32px 16px;\n  }\n  \n  .uag-state__icon {\n    color: #4b5563;\n    opacity: 0.7;\n  }\n  \n  .uag-state__icon--error {\n    color: #ef4444;\n    opacity: 0.85;\n  }\n  \n  .uag-state__text {\n    font-size: 15px;\n    font-weight: 500;\n    color: #d1d5db;\n    margin: 0;\n  }\n  \n  .uag-state__subtext {\n    font-size: 12.5px;\n    color: #6b7280;\n    margin: 0;\n    text-align: center;\n    max-width: 420px;\n  }\n  \n  /* spinner */\n  .uag-spinner {\n    width: 36px;\n    height: 36px;\n    border: 3px solid #2a2d3e;\n    border-radius: 50%;\n    animation: uag-spin 0.75s linear infinite;\n  }\n  \n  @keyframes uag-spin {\n    to { transform: rotate(360deg); }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
